import { render, staticRenderFns } from "./ProductionFlag.vue?vue&type=template&id=0480f837&"
import script from "./ProductionFlag.vue?vue&type=script&lang=js&"
export * from "./ProductionFlag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports